import { render, staticRenderFns } from "./mergeTrend1.vue?vue&type=template&id=18678203&scoped=true&"
import script from "./mergeTrend1.vue?vue&type=script&lang=js&"
export * from "./mergeTrend1.vue?vue&type=script&lang=js&"
import style0 from "./mergeTrend1.vue?vue&type=style&index=0&id=18678203&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18678203",
  null
  
)

export default component.exports